import React, { useState } from 'react';
import { Shapes, Type, Upload } from 'lucide-react';

export default function Sidebar({ children }) {
  const [activeTab, setActiveTab] = useState('shapes');
  const panels = React.Children.toArray(children);

  const tabs = [
    { id: 'shapes', name: 'Create', icon: Shapes, panel: panels[1] },
    { id: 'import', name: 'Import', icon: Upload, panel: panels[0] },
    { id: 'text', name: 'Text', icon: Type, panel: panels[2] }
  ];

  const activePanel = tabs.find((tab) => tab.id === activeTab)?.panel;

  return (
    <aside className="tool-panel">
      <div className="tool-tabs" role="tablist" aria-label="Cadify tools">
        {tabs.map((tab) => {
          const Icon = tab.icon;
          return (
            <button
              key={tab.id}
              type="button"
              className={activeTab === tab.id ? 'active' : ''}
              onClick={() => setActiveTab(tab.id)}
              aria-selected={activeTab === tab.id}
              role="tab"
              title={tab.name}
            >
              <Icon size={18} />
              <span>{tab.name}</span>
            </button>
          );
        })}
      </div>

      <div className="tool-content" role="tabpanel">
        {activePanel}
      </div>
    </aside>
  );
}
